import { action, runInAction } from "mobx"
import noticeStore from "../store/index"
import { reportUserBehaviorCgi } from "@/api/operator/cgi/smb/common"
import { readNotice, getNoticeList } from "../api"

class NoticeService {
  // 获取未读消息数
  @action
  async getUnreadedCount() {
    const data = {
      page: 1,
      is_read: 0,
      is_home_page: 0,
      page_size: noticeStore.noticePageStore.pageSize,
    }
    const res = await getNoticeList({ data })
    if (res.code === 0) {
      runInAction(() => {
        noticeStore.unreadCount = res.data?.conf?.total_num || 0
      })
    }
  }

  // 通知标记完成
  @action
  handleNoticeReaded = (id, pageName, title) => {
    return readNotice({ data: { id } }).then((res) => {
      if (res.code === 0) {
        runInAction(() => {
          noticeStore.noticeReadedId = id
        })
        this.getUnreadedCount()
      }
      reportUserBehaviorCgi({
        data: {
          behavior: "阅读未读公告",
          page1: pageName,
          relation_id: id,
          relation_type: "notice",
          relation_name: title,
        },
      })
    })
  }
}

export default new NoticeService()
